import Api from 'App/api'

export const getDocumentsWithSettings = Api.get({
  controller: 'documents',
  action: 'listWithSettings',
})

export const deleteDocument = Api.post({
  controller: 'documents',
  action: 'delete',
})

export const uploadDocument = Api.postMultipart({
  controller: 'documents',
  action: 'upload',
})

export const signDocument = Api.post({
  controller: 'documents',
  action: 'sign',
})

export const signPage = Api.post({
  controller: 'documents',
  action: 'signPage',
})

export const signBox = Api.post({
  controller: 'documents',
  action: 'signBox',
})

export const getSignatureImages = Api.get({
  controller: 'documents',
  action: 'loadDocumentAndSignatureImages',
})
